import { render, staticRenderFns } from "./SPUsers.vue?vue&type=template&id=b7d75890&"
import script from "./SPUsers.vue?vue&type=script&lang=ts&"
export * from "./SPUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports